import { CampaignCurrency } from "../../enums/campaign.enums";

export class BrandPartnerListBudget {
  constructor(
    public readonly amount: number,
    public readonly currency: CampaignCurrency,
    public readonly currencySymbol: string,
  ) {}
}
